<div class="vh-100 vh-100 d-flex flex-column">
  <div class="content-wrapper">
    <app-navbar
      [showLogo]="showLogo"
      [logoLightPath]="logo.light"
      [logoDarkPath]="logo.dark"
    ></app-navbar>
  </div>

  <div class="flex-grow-1 content-background w-100">
    <div class="content-wrapper">
      @if (loading) {
      <ix-layout-grid>
        <ix-row>
          <ix-col class="d-flex justify-content-center">
            <ix-spinner size="large"></ix-spinner>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
      }

      @if (!loading && passFound) {
      <ix-layout-grid [columns]="12" class="w-100">
        <ix-row>
          <ix-col>
            <ix-content-header headerTitle="{{
                'battery_pass.private.header' | translate: {id: passId}
              }}" id="publicBatteryPassHeader"></ix-content-header>
          </ix-col>
        </ix-row>
        <app-pass-viewer [passport]="passport?.data" [schema]="schema" [uiSchema]="uiSchema">
        </app-pass-viewer>
        <ix-row>
          <ix-col>
            <div class="d-flex flex-column align-items-center text-center gap-2">
              <ix-typography class="pre-wrap" format="body-lg" id="publicBatteryPassLoginLabel">{{
                'battery_pass.public.login_text' | translate }}
                <a href="" id="requestAccessLink" (click)="openRequestAccessModal($event)">
                  {{'battery_pass.public.request_access_text' | translate}}
                </a>
              </ix-typography>
              <ix-button [routerLink]="['/app/view-passport/', passId]" id="publicBatteryPassLoginButton"
                variant="primary">{{ 'general.login' | translate }}
              </ix-button>
              <br />
            </div>
          </ix-col>
        </ix-row>
        <ix-row></ix-row>
      </ix-layout-grid>
      }

      @if (!loading && !passFound) {
      <ix-layout-grid>
        <ix-row>
          <ix-col>
            @if (!passFound) {
            <ix-empty-state action="{{ 'battery_pass.public.action' | translate }}" header="{{
                'battery_pass.list.no_passport_available' | translate
              }}" icon="error" subHeader="{{
                'battery_pass.public.no_pass_sub_header' | translate
              }}"></ix-empty-state>
            }
          </ix-col>
        </ix-row>
      </ix-layout-grid>
      }
    </div>
  </div>

  <div class="content-wrapper">
    <app-footer></app-footer>
  </div>
</div>

<ng-template #requestAccessModal let-modal>
  <div>
    <ix-modal-header>
      {{ 'battery_pass.public.request_access_modal_title' | translate }}
    </ix-modal-header>
    <app-request-access-form [passportId]="passId" (submitted)="modal.close(true)"
      (cancelled)="modal.dismiss('dismiss')" [size]="this.size" [organizationId]="this.schema.organizationId">
    </app-request-access-form>
  </div>
</ng-template>
